import { AbstractIdbaModel } from 'src/app/shared/models/abstract-idba-model';
export class  Pessoa extends AbstractIdbaModel {

  public override convertToModel(data: any): Pessoa {
    return new Pessoa(data);
  }

  public filter(value: string, objectList: Pessoa[]): Pessoa[] {
    const filterValue = value.toLowerCase();
    return objectList.filter(
      (item) =>
        item.nomePessoa.trim().toLowerCase().includes(filterValue) ||
        item.codigoPessoa.toString().toLowerCase().includes(filterValue)
    );
  }

  public displayCodigo(pessoa: Pessoa): string {
    return `${pessoa.codigoPessoa}`;
  }
  public displayNome(pessoa: Pessoa): string {
    return `${pessoa.nomePessoa}`;
  }
  public display(pessoa: Pessoa): string {
    return pessoa && pessoa.codigoPessoa
      ? `${pessoa.codigoPessoa} - ${pessoa.nomePessoa}`
      : '';
  }

  codigoPessoa: number;
  nomePessoa: string;

  codigoCep: string;
  numEndereco: number;
  nomeComplemento: string;

  dataNascimento: Date | null;
  dataImplantacao: Date;

  codigoTipoContato: string;

  codigoInscricaoEstadual: string;
  codigoInscricaoMunicpal: string;

  codigoIndicadorInscricaoEstadual: number;

  nomeUF: string; 
  nomeCidade: string; 
  nomeBairro: string;

  indUsuario: boolean;
}
